import { Modal } from "antd";
import { useState } from "react";

export const RAModal = ({ open, title = "", modalContent, handleOk, handleCancel }) => {
	const [confirmLoading, setConfirmLoading] = useState(false);

	return (
		<>
			<Modal title={title} open={open} onOk={handleOk} confirmLoading={confirmLoading} onCancel={handleCancel}>
				{modalContent}
			</Modal>
		</>
	);
};
